import { Button, Form, Input, Select } from 'antd'
import axios from 'axios';
import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import { alertError, alertSuccess } from '../../../utils/alert';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment/moment';

moment.locale("es");

function Formulario({ form }) {

    const [loading, setLoading] = React.useState(false);
    const [statusCaptcha, setStatusCaptcha] = React.useState(false);
    const refCaptcha = React.useRef();


    const sendDataLayer = async (data) => {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'generate_lead',
                formID: 'form',
                email: data.email,
                name: data.name,
                lastname: data.lastname,
                phone: data.phone,
                company: data.company,
                product: data.product,
                horario: data.horario,
                rut_company: data.rut_company
            });
        } catch (e) {
            console.log(e);
        }
    }


    const sendLead = async (data) => {
        try {
            const response = await axios.post('https://tvorpycnyj.execute-api.sa-east-1.amazonaws.com/production/leads', {
                ...data,
                lastname: data.lastname ? data.lastname : 'No indicado'
            })
            return response
        } catch (error) {
            setLoading(false)
            toast.error('Error al enviar los datos')
        }
    }

    const onFinish = async (e) => {
        setLoading(true)
        try {
            const Fecha = moment().format('DD/MM/YYYY HH:mm:ss')
            const url = "https://script.google.com/macros/s/AKfycbwkkQe1HpGMfu8ObnY0IqPBrHuJwdu-ZP-D93y8tXzgqbjBm_QXpqG7GL218oTpfc6YHg/exec"
            const responSpreedSheet = fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: (`name=${e.name}&lastname=${e.lastname}&company=${e.company}&rut_company=${e.rut_company}&phone=${e.phone}&email=${e.email}&horario=${e.horario}&product=${e.product}&date=${Fecha}`)
            }).then((response) => {
                console.log(response)
            })

            const sendLeadResponse = await sendLead(e)
            const dataLayer = await sendDataLayer(e)
            toast.success('Datos Enviados Correctamente')
            setLoading(false)
            form.resetFields()
            return sendLeadResponse

        } catch (error) {
        }
        if (statusCaptcha === false) {
            setLoading(false)
            return
        }
    }





    return (
        <div id='form' className='w-full'>
            <ToastContainer />
            <div className='w-full container mx-auto py-10 p-5 md:px-0'>

                <h2 className='text-2xl font-bold uppercase'>
                    Datos Para Reunión informativa
                </h2>


                <Form id='form' form={form} onFinish={onFinish} className='w-full md:grid-cols-3 grid-cols-1 grid gap-5 mt-10' >
                    <Form.Item
                        className='mb-2 flex flex-col'
                        name="name"
                        rules={[{ required: true, message: 'Por favor ingrese su nombre' }]}
                    >

                        <Input
                            className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 h-14'
                            placeholder='Nombre' disabled={loading} />
                    </Form.Item>
                    <Form.Item
                        className='mb-2 flex flex-col'
                        name="lastname"
                        rules={[{ message: 'Por favor ingrese su Apellido' }]}
                    >
                        <Input
                            className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 h-14'
                            placeholder='Apellido' disabled={loading} />
                    </Form.Item>
                    <Form.Item
                        className='mb-2 flex flex-col'
                        name="company"
                        rules={[{ required: true, message: 'Por favor ingrese su empresa' }]}
                    >

                        <Input
                            className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 h-14'
                            placeholder='Empresa' disabled={loading} />
                    </Form.Item>

                    <Form.Item
                        className='mb-2 flex flex-col'
                        name="rut_company"
                        rules={[{ required: true, message: 'Por favor ingrese el Rut de la empresa' }]}
                    >

                        <Input
                            className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 h-14'
                            placeholder='Rut Empresa' disabled={loading} />
                    </Form.Item>
                    <Form.Item
                        className='mb-2 flex flex-col justify-center'
                        name="phone"
                        rules={[{ required: true, message: 'Por favor ingrese su telefono',
                            pattern: {
                                value: /^[0-9]{9,9}$/,
                                message: 'Teléfono no valido'
                            },
                            max: 9
                         }]}
                    >
                        <Input
                             addonBefore="+56"
                            className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 '
                            placeholder='Teléfono' disabled={loading} >
                            </Input>
                              
                    </Form.Item>
                    <Form.Item
                        className='mb-2 flex flex-col'
                        name="email"
                        rules={[{
                            required: true,
                            message: 'Por favor ingrese su correo',
                            type: 'email',
                            pattern: {
                                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                message: 'Correo no valido'
                            }
                        }]}>
                        <Input
                            className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 h-14'
                            placeholder='Correo' disabled={loading} />
                    </Form.Item>
                    <Form.Item
                        className='mb-2 flex flex-col'
                        name="horario"
                        rules={[{ required: true, message: 'Por favor ingrese un horario para poder ser contactado' }]}
                    >

                        <Select className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 h-14' placeholder='Horario de contacto' disabled={loading}>
                            <Select.Option value='AM'>AM</Select.Option>
                            <Select.Option value='PM'>PM</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        className='mb-2 flex flex-col '
                        name="product"
                        rules={[{ required: true, message: 'Por favor ingrese un producto' }]}
                    >


                        <Select className='text-blue-500 bg-[#eeeeee] mt-3 placeholder-blue-500 h-14' placeholder='Producto' disabled={loading}>
                            <Select.Option value='Mora Control'>Mora Control</Select.Option>
                            <Select.Option value='Reportes Interactivos'>Reportes Interactivos</Select.Option>
                            <Select.Option value='Control Total'>Control Total</Select.Option>
                            <Select.Option value='Control Total Libre'>Control Total Libre</Select.Option>
                        </Select>
                    </Form.Item>
                    <div>

                    </div>

                    <div className='flex flex-col gap-5'>

                        <ReCAPTCHA
                            ref={refCaptcha}
                            sitekey="6Le4g90qAAAAAPEllrP6xhYjzC3OymmuyiB4TO0F"
                            onChange={(e) => setStatusCaptcha(e)}
                        />
                        <Button
                            type='primary'
                            htmlType='submit'
                            loading={loading}
                            disabled={loading}
                            block={true}
                            className='h-12 text-xl'
                        >
                            {
                                loading ? 'Enviando...' : 'Enviar'
                            }
                        </Button>
                    </div>

                </Form>


            </div>
        </div>
    )
}

export default Formulario